import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from '@angular/forms';
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AcepGlobalModule } from "@acepteam/globalspack";
import * as comps from "./groupportal/components";
import { MaterialModule } from "./shared/material.module";
import { AppRoutingModule } from "./app.routing.module";
import { GroupPortalModule } from "./groupportal/groupportal.module";
import { ClickOutsideModule } from 'ng-click-outside';
import { SafePipe } from "./core/pipes/safe.pipe";



@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [AppComponent, comps.GroupHeaderComponent, comps.SideNavComponent, SafePipe],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    GroupPortalModule,
    ClickOutsideModule,
    CoreModule.forRoot(),
    AcepGlobalModule.forRoot(),
    AppRoutingModule,
    MaterialModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
